module.exports = __webpack_public_path__ + "media/images/sidebar-overview-6c3563d9ad3b1921318f9c3da3d38db2.svg";